// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import {
  type ZugewiesenesFahrzeugAnbauteil,
  ZugewiesenesFahrzeugAnbauteilDaten,
} from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useAssignAnbauteilZuFahrzeug(): (
  fahrzeugId: string,
  anbauteilId: string,
  requestBody: ZugewiesenesFahrzeugAnbauteilDaten
) => Promise<ZugewiesenesFahrzeugAnbauteil> {
  const getAPI = useGetApi();
  return useCallback(
    async (fahrzeugId, anbauteilId, requestBody) =>
      (await getAPI()).fahrzeuge.assignAnbauteilZuFahrzeug({
        fahrzeugId,
        anbauteilId,
        requestBody,
      }),
    [getAPI]
  );
}
